// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import openPrintDialog from "@insite/client-framework/Common/Utilities/openPrintDialog";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@steiner/App/Components/Common/XngZone";
import ImprovePageLink from "@steiner/App/Components/ImprovePageLink/ImprovePageLink";
import { CustomAppState } from "@steiner/App/Store/Reducers";
import { isNonStockProduct } from "@steiner/App/Store/Selectors/ProductDetailsSelector";
import * as React from "react";
import { FC } from "react";

interface OwnProps {
    widgetId: string;
}
export interface ProductDetailsButtonsStyles {
    container?: InjectableCss;
    printLink?: LinkPresentationProps;
}

export const productDetailsButtonsStyles: ProductDetailsButtonsStyles = {};

const styles = productDetailsButtonsStyles;

type Props = OwnProps & HasProduct;

const ProductDetailsButtons: FC<Props> = ({ product, widgetId }) => {
    const { isNonStockItem } = useAppSelector(state => ({
        isNonStockItem: isNonStockProduct(state as CustomAppState, product.id),
    }));

    if (isNonStockItem) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container} data-test-selector="product_details_buttons">
            <Link {...styles.printLink} onClick={openPrintDialog} data-test-selector="cartActionsPrint">
                {translate("Print")}
            </Link>
            <XngZone contentId={widgetId} zoneName="Content07" hint="Share Link" />
            <ImprovePageLink />
        </StyledWrapper>
    );
};

export default withProduct(ProductDetailsButtons);
